export enum PrincingType {
    SimplePrice = 'SimplePrice',
    FixedPerRange = 'FixedPerRange',
    PerRangeLength = 'PerRangeLength'
}
